import React from "react";
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from "@mui/icons-material/Delete";
import UpdateIcon from "@mui/icons-material/Update";
import ModeEditOutlineRoundedIcon from "@mui/icons-material/ModeEditOutlineRounded";
import TuneIcon from "@mui/icons-material/Tune";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import SendIcon from '@mui/icons-material/Send';
import ModeIcon from '@mui/icons-material/Mode';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import SaveIcon from '@mui/icons-material/Save';
import NoteIcon from '@mui/icons-material/Note';
import SearchIcon from '@mui/icons-material/Search';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import MergeIcon from '@mui/icons-material/Merge';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import SettingsIcon from '@mui/icons-material/Settings';
import RefreshIcon from '@mui/icons-material/Refresh';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DescriptionIcon from "@mui/icons-material/Description";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LoopIcon from '@mui/icons-material/Loop';
import { Box } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';

const sizeHeights = {
    small: 32,
    medium: 40,
    large: 48
};

const CommonButton = (props) => {
    const {
        icon,
        label,
        variant = "contained",
        size = "medium",
        onClick,
        onBlur,
        disabled = false,
        width,
        'data-testid': dataTestId,
        id,
        endIcon,
        buttonRef=null,
        ...restProps
    } = props;

    // The theme now handles icon colors automatically via inheritance, 
    // but we can pass styles if specific icons (like add-round) need them.
    function getIcon(iconName) {
        if (!iconName) return null;

        const roundIconStyle = { color: "#f9f9f9ff" };

        const icons = {
            "add": <AddIcon />,
            "add-round": <AddCircleRoundedIcon style={roundIconStyle} />,
            "delete": <DeleteIcon />,
            "update": <UpdateIcon />,
            "edit": <ModeEditOutlineRoundedIcon />,
            "advanced": <TuneIcon />,
            "export": <UploadFileIcon />,
            "download": <DownloadIcon />,
            "upload": <UploadIcon />,
            "print": <LocalPrintshopOutlinedIcon />,
            "eye": <RemoveRedEyeOutlinedIcon />,
            "send": <SendIcon />,
            "pencil": <ModeIcon />,
            "generate": <HourglassEmptyIcon />,
            "save": <SaveIcon />,
            "contact": <ContactPageIcon />,
            "template": <NoteIcon />,
            "search": <SearchIcon />,
            "assignment": <AssignmentRoundedIcon />,
            "cancel": <CloseRoundedIcon />,
            "reset": <RestartAltIcon />,
            "merge": <MergeIcon />,
            "settings": <SettingsIcon />,
            "refresh": <RefreshIcon />,
            "exportIcon": <FileUploadOutlinedIcon />,
            "importIcon": <FileDownloadOutlinedIcon />,
            "money": <AttachMoneyIcon />,
            "page":<DescriptionIcon />,
            "permission":<AdminPanelSettingsIcon />,
            "view":<RemoveRedEyeIcon />,
            "loop": <LoopIcon />,
            "circle":<CheckCircleIcon />,
            "assign": <PersonAddAltIcon />
        };

        return icons[iconName] || null;
    }

    return (
        <Box>
            <Button
                variant={variant}
                size={size}
                startIcon={getIcon(icon)}
                onClick={onClick}
                disabled={disabled}
                onBlur={onBlur}
                id={id ?? 'common-btn'}
                data-testid={dataTestId}
                ref={buttonRef}
                endIcon={endIcon ?? null}
                sx={{ 
                    width: width ?? 'auto',
                    height: `${sizeHeights[size] || sizeHeights.medium}px !important`
                }}
                {...restProps}
            >
                {label}
            </Button>
        </Box>
    );
};

export default CommonButton;
